import { useCallback } from "react";
import { Row } from "@evergis/ui";
import { useSelector } from "react-redux";
import { getAppConfig } from "../../../ducks/appConfig";

import { useShowFeatureCard } from "./useShowFeatureCard";

export const useTableMenu = (layerName: string) => {
  const showFeatureCard = useShowFeatureCard(layerName);
  const { settings } = useSelector(getAppConfig);

  const onShowCard = useCallback(
    (row: Row) => {
      return showFeatureCard(row.id as string, !settings?.autoZoomFromTable);
    },
    [showFeatureCard, settings],
  );

  return { onShowCard };
};
